export const qaTypes = new Map([
  ['1', '预定相关'],
  ['2', '费用相关'],
  ['3', '服务相关'],
  ['4', '取消订单'],
])
